const GoogleAppsDetailsMainPanel = () => import('client/SoftwareApps/GoogleAppsDetailsMainPanel.vue');

const googleAppTitle = 'Software Management/Google Tab';

export default [
  {
    path: '/managedSoftware/google/:id/details',
    name: 'googleAppDetailsPanel',
    meta: {
      title: googleAppTitle,
      returnPath: '/managedSoftware/google',
    },
    components: {
      mainPanel: GoogleAppsDetailsMainPanel,
    },
  },
];
